<template>
    <div>
        <Modal title="绑定微信二维码" v-model="value" :mask-closable="false" width="360" footer-hide on-visible-change="visibleChange">
            <div slot="close">
                <Icon type="ios-close" size="31" color="#999" @click="cancel" />
            </div>
            <div class="code-box">
                <img :src="QRImg" alt="" />
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            QRImg: '',
        };
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
        // QRImg: {
        //     type: String,
        //     required: true
        // }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
    },
    methods: {
        init() {
            this.$Spin.show();
            this.QRImg = `${this.$constDefinition.baseUrl}/shbfile/previewAfterSalesPersonnelQRcode/afterSalesPersonnelId?afterSalesPersonnelId=${this.id}`;
            this.$Spin.hide();
        },
        visibleChange(value) {
            if (!value) {
                this.$emit('close', value);
            }
        },
        cancel() {
            this.$emit('close', false);
        },
    },
};
</script>

<style lang="less" scoped>
.code-box {
    height: 360px;
    img {
        width: 100%;
    }
}
</style>
